/// <reference types="vite/client" />
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { initGTM } from './src/lib/gtm';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

const queryClient = new QueryClient();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find root element to mount to');
}

const root = createRoot(rootElement);

// Initialize Google Tag Manager if provided via Vite env var `VITE_GTM_ID`
initGTM(import.meta.env?.VITE_GTM_ID as string | undefined);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
